module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_remer",
    attrs: {
      "epub:type": "acknowledgments"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_IX",
      "title": "IX"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Acknowledgments")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITH THE SAME INEVITABILITY")]), _vm._v(" as the dawn follows from the night, I have a multitude of friends and colleagues to thank, each of whom—in their own way, whether they know it or not—have been instrumental in the production of this book. First, I wish to record my thanks to David Congdon, easily one of the most creative and insightful theologians working today. As a one-time editor at IVP Academic, it was David who first encouraged me in this project and who steered the proposal through to its acceptance. Even though he has moved on to other work opportunities, I continue to learn from him. I am grateful also to friends at the University of Divinity, in particular Scott Kirkland, Geoff Thompson, and Chris Mostert, with whom I have enjoyed countless conversations about this book, and who have offered invaluable feedback. The end product is by far the better for their advice (and for me having taken it!). My thanks must also go to my colleagues at Trinity College Theological School, particularly to Dorothy Lee and Bob Derrenbacker—successive deans under whose leadership of the school this book has been written—and to Professor Ken Hinchcliff, warden of Trinity College, who has been unfailing in his support for the research ambitions of the theological school.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I am delighted to record my very sincere thanks to David McNutt, who took over the editorial reins for this project in early 2017 and has been wonderful to work with every step of the way. I am grateful to him for his sharp eye for detail and for the astute questions he posed of the text at various points.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_X",
      "title": "X"
    }
  }, [_vm._v("Close friends are, of course, the often-unheralded supporters of projects such as this, and of their authors. Frequently unfamiliar with the material, their value is simply in "), _c('i', [_vm._v("being there")]), _vm._v(": in enquiring about progress, in celebrating the reaching of project milestones, and—most importantly of all—in reminding us authors that there is a wider world out there, away from the books and the research. The company of dear friends, over meals and wine, is a gift of inestimable worth. And so I record here my thanks to Samuel and Jazz, Kath and Greg, Phil and Jane, Paul and Christina, and Luke and Alice. You have shepherded me and my family not only through the slow progress of this project but even more so through the various other ups and downs over the past few years. You know what I mean. Thank you.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Finally, to my family—I cannot repay the debt I owe you. You have been unfailingly good to me, and I cannot—no, "), _c('i', [_vm._v("will ")]), _vm._v("not—ever forget that. Let me say, and promise, simply this: each of you is infinitely more important to me than this or any book. Forgive me for those times when that has not been as evident as it should have been. Sonia, Jack, Tom, and Elijah—for what it is worth, this is for you, with my love.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 69
// module chunks = 0